import {
  BOX_SHADOW_BUTTON,
  GRADIENT_INSTAGRAM,
  INPUT_COLOR_BORDER,
  PRIMARY_COLOR_TEXT,
} from "../../utils/colors";

export const gallerySecondaryCircleSurfaceSx = (theme) => ({
  backgroundColor: theme.palette.button.secondary.main,
  color: PRIMARY_COLOR_TEXT,
  border: `1px solid ${INPUT_COLOR_BORDER}`,
  boxShadow: BOX_SHADOW_BUTTON,
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
});

export const galleryPublishButtonSx = {
  background: GRADIENT_INSTAGRAM,
  border: "none",
  overflow: "visible",
  boxShadow:
    "0 6px 14px rgba(34, 211, 238, 0.22), 0 2px 10px rgba(0, 0, 0, 0.32), inset 0 0 0 1px rgba(255, 255, 255, 0.28)",
  width: "auto",
  minWidth: "auto",
  height: 32,
  flexShrink: 0,
  px: 1.25,
  borderRadius: 10,
  color: "#fff",
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
  "&:hover": {
    background: GRADIENT_INSTAGRAM,
    boxShadow:
      "0 6px 16px rgba(34, 211, 238, 0.28), 0 3px 12px rgba(0, 0, 0, 0.36), inset 0 0 0 1px rgba(255, 255, 255, 0.34)",
    filter: "brightness(1.06) saturate(1.05)",
  },
  "& .MuiTypography-root": {
    display: "block",
    whiteSpace: "nowrap",
    lineHeight: 1,
  },
  "& svg": {
    flexShrink: 0,
    width: 16,
    height: 16,
  },
  "@container (max-width: 260px)": {
    height: 30,
    px: 0.75,
    "& .MuiTypography-root": {
      fontSize: "0.68rem",
    },
    "& svg": {
      width: 15,
      height: 15,
    },
  },
  "@container (max-width: 220px)": {
    height: 28,
    px: 0.5,
    "& .MuiTypography-root": {
      fontSize: "0.6rem",
    },
    "& svg": {
      width: 14,
      height: 14,
    },
  },
  "@container (max-width: 180px)": {
    height: 26,
    px: 0.4,
    "& .MuiTypography-root": {
      fontSize: "0.55rem",
    },
    "& svg": {
      width: 12,
      height: 12,
    },
  },
};

export const getGallerySecondaryLabeledButtonSx = (theme) => ({
  ...gallerySecondaryCircleSurfaceSx(theme),
  width: "auto",
  minWidth: "auto",
  height: 32,
  flexShrink: 0,
  px: 1.25,
  borderRadius: 10,
  overflow: "visible",
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
  "&:hover": {
    backgroundColor: `${theme.palette.button.secondary.hover.main} !important`,
  },
  "& .MuiTypography-root": {
    display: "block",
    whiteSpace: "nowrap",
    lineHeight: 1,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 16,
  },
  "@container (max-width: 260px)": {
    height: 30,
    px: 0.75,
    "& .MuiTypography-root": {
      fontSize: "0.68rem",
    },
    "& .MuiSvgIcon-root": {
      fontSize: 15,
    },
  },
  "@container (max-width: 220px)": {
    height: 28,
    px: 0.5,
    "& .MuiTypography-root": {
      fontSize: "0.6rem",
    },
    "& .MuiSvgIcon-root": {
      fontSize: 14,
    },
  },
  "@container (max-width: 180px)": {
    height: 26,
    px: 0.4,
    "& .MuiTypography-root": {
      fontSize: "0.55rem",
    },
    "& .MuiSvgIcon-root": {
      fontSize: 12,
    },
  },
});

export const gallerySecondaryToolbarIconSx = ({
  theme,
  iconSvgFontSize = 16,
  buttonSize = 28,
}) => ({
  "& .MuiIconButton-root": {
    ...gallerySecondaryCircleSurfaceSx(theme),
    border: "none",
    width: buttonSize,
    height: buttonSize,
    minWidth: buttonSize,
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: `${theme.palette.button.secondary.hover.main} !important`,
      color: `${PRIMARY_COLOR_TEXT} !important`,
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(255, 255, 255, 0.8) !important",
      color: "rgba(0, 0, 0, 0.4) !important",
    },
    "& .MuiSvgIcon-root": {
      fontSize: iconSvgFontSize,
    },
  },
});

/**
 * Glass box material fills the full button edge-to-edge (no rim/border).
 */
const galleryLiquidGlassMaterialSx = {
  content: '""',
  position: "absolute",
  inset: 0,
  borderRadius: "inherit",
  pointerEvents: "none",
  zIndex: 0,
  background: "rgba(255, 255, 255, 0.38)",
  backdropFilter: "blur(20px) saturate(1.7)",
  WebkitBackdropFilter: "blur(20px) saturate(1.7)",
};

export const getGalleryLiquidGlassSx = () => ({
  position: "relative",
  display: "inline-flex !important",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  boxSizing: "border-box",
  backgroundColor: "transparent !important",
  backgroundImage: "none !important",
  background: "transparent !important",
  color: PRIMARY_COLOR_TEXT,
  border: "none !important",
  outline: "none !important",
  boxShadow: "0 6px 18px rgba(0, 0, 0, 0.16)",
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
  padding: "0 12px !important",
  height: "32px !important",
  minHeight: "32px !important",
  maxHeight: "32px !important",
  lineHeight: 1,
  "&::before": galleryLiquidGlassMaterialSx,
  "&::after": {
    display: "none",
  },
  "& > *": {
    position: "relative",
    zIndex: 1,
    display: "inline-flex !important",
    alignItems: "center",
    justifyContent: "center",
    height: "32px",
    lineHeight: 1,
    margin: 0,
    padding: 0,
  },
  "& .MuiTypography-root": {
    display: "inline-flex !important",
    alignItems: "center",
    justifyContent: "center",
    height: "32px",
    margin: "0 !important",
    padding: "0 !important",
    lineHeight: "1 !important",
    transform: "translateY(0.5px)",
  },
  "&:hover": {
    backgroundColor: "transparent !important",
    backgroundImage: "none !important",
    background: "transparent !important",
    border: "none !important",
    boxShadow: "0 8px 22px rgba(0, 0, 0, 0.2)",
    filter: "none",
    "&::before": {
      background: "rgba(255, 255, 255, 0.48)",
    },
  },
  "&.Mui-disabled": {
    backgroundColor: "transparent !important",
    backgroundImage: "none !important",
    background: "transparent !important",
    color: "rgba(0, 0, 0, 0.4) !important",
    border: "none !important",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    "&::before": {
      background: "rgba(255, 255, 255, 0.28)",
      backdropFilter: "blur(14px)",
      WebkitBackdropFilter: "blur(14px)",
    },
  },
});

export const getGallerySecondaryLiquidGlassSx = getGalleryLiquidGlassSx;
export const galleryPrimaryLiquidGlassSx = getGalleryLiquidGlassSx();

export const mergeGalleryLiquidGlassSx = ({ baseSx }) => {
  const liquidGlassSx = getGalleryLiquidGlassSx();

  return {
    ...baseSx,
    ...liquidGlassSx,
    border: "none !important",
    padding: "0 12px !important",
    height: "32px !important",
    minHeight: "32px !important",
    maxHeight: "32px !important",
    "&:hover": {
      filter: "none",
      border: "none !important",
      ...(liquidGlassSx["&:hover"] || {}),
    },
    "&.Mui-disabled": {
      filter: "none",
      border: "none !important",
      ...(liquidGlassSx["&.Mui-disabled"] || {}),
    },
  };
};
